import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AppConstants } from "../constants/constants";
import { Steps } from "../constants/steps";
import { LearnerCourseLogService } from "../_services/learner-course-log.service";

@Injectable({
  providedIn: "root",
})
export class LearningGuard implements CanActivate {
  constructor(
    private router: Router,
    private learnerCourseLogService: LearnerCourseLogService
  ) {}

  canActivate(route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> {
    var courseId =
      +this.router.getCurrentNavigation().extractedUrl.queryParams[
        AppConstants.COURSE_ID
      ];
    return this.checkIfLearnerIsAlreadyOnLearningStep(courseId);
  }

  checkIfLearnerIsAlreadyOnLearningStep(courseId: number): Observable<boolean> {
    return this.learnerCourseLogService.getLearnerCourseLog$(courseId).pipe(
      map((log) => {
        if (log.componentUrl == Steps.Learning) return true;
        this.redirectToDashboard();
        return false;
      }),
      catchError((err) => {
        console.error(err);
        this.redirectToDashboard();
        return of(false);
      })
    );
  }

  redirectToDashboard() {
    this.router.navigate(["/dashboard"]);
  }
}
